const footerGroups = [
  {
    title: "Product",
    links: [
      { href: "/how-it-works", label: "How it Works" },
      { href: "/product", label: "Spaces" },
      { href: "/support", label: "For your group" },
      { href: "/pricing", label: "Pricing" },
      { href: "/download", label: "Download" }
    ]
  },
  {
    title: "Trust",
    links: [
      { href: "/privacy-security", label: "Privacy & Security" },
      { href: "/whitepaper", label: "Whitepaper" },
      { href: "/safety", label: "Contact / Safety" }
    ]
  },
  {
    title: "Legal",
    links: [
      { href: "/terms", label: "Terms of Use" },
      { href: "/privacy", label: "Privacy Policy" },
      { href: "/open-source", label: "Open Source Notices" }
    ]
  }
] as const;

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <a className="brand-link" href="/">
            <span className="brand-dot" aria-hidden="true" />
            <span>Booply</span>
          </a>
          <p>Coordination that stays between you.</p>
        </div>
        <nav aria-label="Footer" className="footer-nav">
          {footerGroups.map((group) => (
            <section key={group.title}>
              <h2>{group.title}</h2>
              {group.links.map((link) => (
                <a href={link.href} key={link.href}>{link.label}</a>
              ))}
            </section>
          ))}
        </nav>
      </div>
    </footer>
  );
}
